import { render, staticRenderFns } from "./ModalPatientForm.vue?vue&type=template&id=00a778c9&lang=pug"
import script from "./ModalPatientForm.vue?vue&type=script&lang=js"
export * from "./ModalPatientForm.vue?vue&type=script&lang=js"
import style0 from "./ModalPatientForm.vue?vue&type=style&index=0&id=00a778c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports